import { Field, ID, InputType } from 'type-graphql'
import { QueryArgs } from '../../action'
import type { AiCreditTransaction } from './AiCreditTransaction'

/** Same shape as `GetAiCreditTransactionListArgs` — `options` is inherited but unused by `AiCreditTransactionListService.getMeta`. */
@InputType()
export class GetAiCreditTransactionListMetaArgs extends QueryArgs<AiCreditTransaction> {
  /** Target owner to read — a `User._id` (User scope) or `Tenant._id` (Tenant scope). The caller supplies this explicitly and must hold `canManageAiBilling`. */
  @Field(() => ID)
  ownerId: string
}
